/**
 * @param {Number} number
 * @param {Array} variants
 * @return {String}
 */
export function inflection(number, variants) {
    if (number === 1) return variants[0];
    else if (number > 1 && number < 5) return variants[1];
    else return variants[2];
}

/**
 * @param {String} string
 * @return {String}
 */
export function clearDiacritics(string) {
    if (string === undefined) return '';
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * @param {Number} length
 * @return {String}
 */
export function stringGenerator(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

/**
 * @param {String} string
 * @param {String} separator
 * @return {string}
 */
export function slugify(string, separator = '-') {
    const a = 'ěščřžýáíéúůàáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
    const b = 'escrzyaieuuaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string.toString().toLowerCase()
        .replace(/\s+/g, separator)
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, separator)
        .replace(/^-+/, '')
        .replace(/-+$/, '')
};
